import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=7b9614e0&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=js&"
export * from "./tinymce.vue?vue&type=script&lang=js&"
import style0 from "./tinymce.vue?vue&type=style&index=0&id=7b9614e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9614e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9614e0')) {
      api.createRecord('7b9614e0', component.options)
    } else {
      api.reload('7b9614e0', component.options)
    }
    module.hot.accept("./tinymce.vue?vue&type=template&id=7b9614e0&scoped=true&", function () {
      api.rerender('7b9614e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/tinymce.vue"
export default component.exports